import { ALTERAR_REGISTROS_POR_PAGINA_FECHAMENTO_CAIXA } from '../types'

export default function alterarRegistrosPorPaginaFechamentoCaixa (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_FECHAMENTO_CAIXA,
    payload: valor
  }
}
